import {
  FETCH_VIDEOS,
  FETCH_VIDEOS_SUCCESS,
  FETCH_VIDEOS_FAIL,
  FETCH_VIDEO_DETAIL,
  FETCH_VIDEO_DETAIL_SUCCESS,
  FETCH_VIDEO_DETAIL_FAIL,
  PLAY_VIDEO,
  PAUSE_VIDEO,
  SET_VIDEO_PROGRESS,
  SET_VIDEO_VOLUME,
} from './constants';

const INIT_STATE = {
  videos: [],
  currentPage: 1,
  lastPage: 1,
  loading: false,
  error: null,
  currentVideo: null,
  videoDetail: null,
  isPlaying: false,
  progress: 0,
  volume: 1,
  duration: 0,
};

const Video = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_VIDEOS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_VIDEOS_SUCCESS:
      const { data, resetVideos } = action.payload;
      return {
        ...state,
        loading: false,
        videos: resetVideos ? data.data : [...state.videos, ...data.data],
        currentPage: data.current_page,
        lastPage: data.last_page,
        error: null,
      };

    case FETCH_VIDEOS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        videos: action.payload.data,
      };

    case FETCH_VIDEO_DETAIL:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_VIDEO_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        videoDetail: action.payload,
        error: null,
      };

    case FETCH_VIDEO_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case PLAY_VIDEO:
      return {
        ...state,
        isPlaying: true,
        currentVideo: action.payload,
      };

    case PAUSE_VIDEO:
      return {
        ...state,
        isPlaying: false,
      };

    case SET_VIDEO_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
        duration: action.payload.duration || state.duration,
      };

    case SET_VIDEO_VOLUME:
      return {
        ...state,
        volume: action.payload,
      };

    default:
      return state;
  }
};

export default Video;
